let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iuOzF")).then(() => parcelRequire('3rNQG'));